(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dani-FAQ"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-faq-seccion]').forEach(function(seccion) {
      var tabs = seccion.querySelectorAll('[data-faq-tab]');
      var paneles = seccion.querySelectorAll('[data-faq-panel]');
      var indicador = seccion.querySelector('[data-faq-indicador]');

      function posicionarIndicador(tab) {
        if (!indicador || !tab) return;
        var rect = tab.getBoundingClientRect();
        var contenedor = tab.parentElement;
        var contRect = contenedor.getBoundingClientRect();
        var paddingStr = getComputedStyle(contenedor).paddingLeft;
        var padding = parseFloat(paddingStr) || 0;
        var left = rect.left - contRect.left - padding;
        indicador.style.width = rect.width + 'px';
        indicador.style.transform = 'translateX(' + left + 'px)';
      }

      if (tabs.length > 0 && indicador) {
        var primera = seccion.querySelector('.faq-tab--activa') || tabs[0];
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            posicionarIndicador(primera);
          });
        });

        window.addEventListener('resize', function() {
          window.requestAnimationFrame(function() {
            var activa = seccion.querySelector('.faq-tab--activa');
            posicionarIndicador(activa);
          });
        });
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var id = this.getAttribute('data-faq-tab');
          tabs.forEach(function(t) {
            t.classList.remove('faq-tab--activa');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('faq-tab--activa');
          this.setAttribute('aria-selected', 'true');
          paneles.forEach(function(panel) {
            if (panel.getAttribute('data-faq-panel') === id) {
              panel.classList.add('faq-panel--activo');
            } else {
              panel.classList.remove('faq-panel--activo');
              panel.querySelectorAll('details[open]').forEach(function(d) { d.removeAttribute('open'); });
            }
          });
          posicionarIndicador(this);
        });
      });

      var detalles = seccion.querySelectorAll('.faq-item');
      detalles.forEach(function(det) {
        det.addEventListener('toggle', function() {
          if (this.open) {
            detalles.forEach(function(otro) {
              if (otro !== det && otro.open) otro.removeAttribute('open');
            });
          }
        });
      });

      var scrollContenedor = seccion.querySelector('[data-faq-tabs]');
      var scrollThumb = seccion.querySelector('[data-faq-scroll-thumb]');
      var scrollIndicador = seccion.querySelector('[data-faq-scroll-indicador]');

      if (scrollContenedor && scrollThumb && scrollIndicador) {
        var medidaMaxScroll = 0;
        var medidaTrackAncho = 0;
        var medidaThumbAncho = 0;
        var ultimoScrollLeft = 0;
        var pintadoPendiente = false;

        function pintarIndicador() {
          if (medidaMaxScroll <= 0) return;
          var progreso = ultimoScrollLeft / medidaMaxScroll;
          if (progreso < 0) progreso = 0;
          if (progreso > 1) progreso = 1;
          var desplazamiento = progreso * (medidaTrackAncho - medidaThumbAncho);
          scrollThumb.style.transform = 'translateX(' + desplazamiento + 'px)';
        }

        function medirIndicador() {
          var scrollWidth = scrollContenedor.scrollWidth;
          var clientWidth = scrollContenedor.clientWidth;
          var scrollLeftActual = scrollContenedor.scrollLeft;
          if (scrollWidth <= clientWidth + 2) {
            scrollIndicador.style.display = 'none';
            medidaMaxScroll = 0;
            return;
          }
          scrollIndicador.style.display = '';
          var ratio = clientWidth / scrollWidth;
          var thumbAnchoPct = Math.max(8, ratio * 100);
          scrollThumb.style.width = thumbAnchoPct + '%';
          scrollThumb.style.left = '0';
          medidaMaxScroll = scrollWidth - clientWidth;
          ultimoScrollLeft = scrollLeftActual;
          window.requestAnimationFrame(function() {
            medidaTrackAncho = scrollThumb.parentElement.clientWidth;
            medidaThumbAncho = scrollThumb.offsetWidth;
            pintarIndicador();
          });
        }

        scrollContenedor.addEventListener('scroll', function() {
          ultimoScrollLeft = scrollContenedor.scrollLeft;
          if (pintadoPendiente) return;
          pintadoPendiente = true;
          window.requestAnimationFrame(function() {
            pintadoPendiente = false;
            pintarIndicador();
          });
        }, { passive: true });

        window.addEventListener('resize', function() {
          window.requestAnimationFrame(medirIndicador);
        });

        if (window.ResizeObserver) {
          var ro = new ResizeObserver(function() {
            window.requestAnimationFrame(medirIndicador);
          });
          ro.observe(scrollContenedor);
        } else {
          window.requestAnimationFrame(medirIndicador);
        }

        setTimeout(function() { window.requestAnimationFrame(medirIndicador); }, 100);
        setTimeout(function() { window.requestAnimationFrame(medirIndicador); }, 500);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-articulo-blog"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.ba-articulo-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.baInicializado === 'true') return;
      seccion.dataset.baInicializado = 'true';

      var contenido = seccion.querySelector('[data-ba-contenido]');
      var tocWrapper = seccion.querySelector('[data-ba-toc]');
      var tocList = seccion.querySelector('[data-ba-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'ba-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-clientes"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.ml-seccion').forEach(function(seccion) {
      seccion.classList.add('ml-revelar');

      var observadorReveal = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ml-visible');
            observadorReveal.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      observadorReveal.observe(seccion);

      var observadorViewport = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ml-en-viewport');
          } else {
            entry.target.classList.remove('ml-en-viewport');
          }
        });
      }, { rootMargin: '100px 0px' });
      observadorViewport.observe(seccion);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-feed-instagran"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.feed-ig-seccion');
  if (!secciones.length) return;

  if (!('IntersectionObserver' in window)) {
    secciones.forEach(function(s) { s.classList.remove('feed-ig-revelar'); });
    return;
  }

  secciones.forEach(function(seccion) {
    seccion.classList.add('feed-ig-revelar');
  });

  var observadorReveal = new IntersectionObserver(function(entradas) {
    entradas.forEach(function(entrada) {
      if (entrada.isIntersecting) {
        entrada.target.classList.add('feed-ig-visible');
        observadorReveal.unobserve(entrada.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  secciones.forEach(function(seccion) {
    observadorReveal.observe(seccion);

    var enlaces = seccion.querySelectorAll('.feed-ig-media-link');
    enlaces.forEach(function(enlace) {
      var video = enlace.querySelector('[data-feed-ig-video]');
      if (!video) return;

      var playRequest = null;

      function reproducir() {
        try {
          video.currentTime = 0;
          playRequest = video.play();
          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(function() {});
          }
        } catch (e) {}
      }

      function pausar() {
        try {
          if (playRequest && typeof playRequest.then === 'function') {
            playRequest.then(function() { video.pause(); }).catch(function() {});
          } else {
            video.pause();
          }
        } catch (e) {}
      }

      enlace.addEventListener('mouseenter', reproducir);
      enlace.addEventListener('mouseleave', pausar);
      enlace.addEventListener('focusin', reproducir);
      enlace.addEventListener('focusout', pausar);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarBuscador(wrapper) {
    var formularios = wrapper.querySelectorAll('[data-form-buscador], .encabezado-rafas__form-buscador--movil');
    formularios.forEach(function(form) {
      var input = form.querySelector('[data-input-buscar], .encabezado-rafas__input-buscar');
      if (!input) return;
      function actualizarEstado() {
        if (input.value.length > 0) {
          form.classList.add('tiene-texto');
        } else {
          form.classList.remove('tiene-texto');
        }
      }
      input.addEventListener('input', actualizarEstado);
      input.addEventListener('change', actualizarEstado);
      form.addEventListener('reset', function() {
        setTimeout(actualizarEstado, 0);
      });
      actualizarEstado();
    });
  }

  var CLAVE_HISTORIAL = 'encRafasHistorial';
  var MAX_HISTORIAL = 8;

  function leerHistorial() {
    try {
      var raw = localStorage.getItem(CLAVE_HISTORIAL);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function guardarHistorial(lista) {
    try { localStorage.setItem(CLAVE_HISTORIAL, JSON.stringify(lista)); } catch (e) {}
  }

  function anadirAHistorial(item) {
    var lista = leerHistorial();
    lista = lista.filter(function(x) {
      if (item.tipo === 'producto') return x.url !== item.url;
      return !(x.tipo === 'busqueda' && x.texto === item.texto);
    });
    lista.unshift(item);
    if (lista.length > MAX_HISTORIAL) lista = lista.slice(0, MAX_HISTORIAL);
    guardarHistorial(lista);
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function resaltar(texto, query) {
    if (!query) return escapeHtml(texto);
    var safe = escapeHtml(texto);
    var safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    try {
      var re = new RegExp('(' + safeQuery + ')', 'gi');
      return safe.replace(re, '<b>$1</b>');
    } catch (e) { return safe; }
  }

  function inicializarPredictivo(wrapper, config) {
    var bloques = [
      {
        input: wrapper.querySelector('[data-predictivo-input]'),
        panel: wrapper.querySelector('[data-predictivo-panel]'),
        inicial: wrapper.querySelector('[data-predictivo-inicial]'),
        historialWrap: wrapper.querySelector('[data-predictivo-historial-wrap]'),
        historialItems: wrapper.querySelector('[data-predictivo-historial-items]'),
        resultados: wrapper.querySelector('[data-predictivo-resultados]'),
        colIzq: wrapper.querySelector('[data-predictivo-col-izq]'),
        colDer: wrapper.querySelector('[data-predictivo-col-der]'),
        cargando: wrapper.querySelector('[data-predictivo-cargando]'),
        vacio: wrapper.querySelector('[data-predictivo-vacio]'),
        limpiar: wrapper.querySelector('[data-predictivo-limpiar-historial]')
      },
      {
        input: wrapper.querySelector('[data-predictivo-input-movil]'),
        panel: wrapper.querySelector('[data-predictivo-panel-movil]'),
        inicial: wrapper.querySelector('[data-predictivo-inicial-movil]'),
        historialWrap: wrapper.querySelector('[data-predictivo-historial-wrap-movil]'),
        historialItems: wrapper.querySelector('[data-predictivo-historial-items-movil]'),
        resultados: wrapper.querySelector('[data-predictivo-resultados-movil]'),
        colIzq: wrapper.querySelector('[data-predictivo-col-izq-movil]'),
        colDer: wrapper.querySelector('[data-predictivo-col-der-movil]'),
        cargando: wrapper.querySelector('[data-predictivo-cargando-movil]'),
        vacio: wrapper.querySelector('[data-predictivo-vacio-movil]'),
        limpiar: wrapper.querySelector('[data-predictivo-limpiar-historial-movil]')
      }
    ];

    bloques.forEach(function(b) {
      if (!b.input || !b.panel) return;
      configurarBloque(b, config, wrapper);
    });
  }

  function configurarBloque(b, config, wrapper) {
    var timer = null;
    var ultimaQuery = '';

    function mostrarInicial() {
      var historial = leerHistorial();
      if (historial.length > 0 && b.historialWrap && b.historialItems) {
        b.historialItems.innerHTML = '';
        historial.forEach(function(item) {
          if (item.tipo === 'producto') {
            var a = document.createElement('a');
            a.className = 'encabezado-rafas__predictivo-item-historial';
            a.href = item.url;
            a.innerHTML = (item.imagen ? '<img src="' + escapeHtml(item.imagen) + '" alt="" loading="lazy" decoding="async" width="44" height="44">' : '') + '<span>' + escapeHtml(item.titulo) + '</span>';
            b.historialItems.appendChild(a);
          } else {
            var btn = document.createElement('a');
            btn.className = 'encabezado-rafas__predictivo-item-historial';
            btn.href = config.searchUrl + '?q=' + encodeURIComponent(item.texto) + '&type=product';
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg><span>' + escapeHtml(item.texto) + '</span>';
            b.historialItems.appendChild(btn);
          }
        });
        b.historialWrap.hidden = false;
      } else if (b.historialWrap) {
        b.historialWrap.hidden = true;
      }
      if (b.inicial) b.inicial.hidden = false;
      if (b.resultados) b.resultados.hidden = true;
      if (b.cargando) b.cargando.hidden = true;
      if (b.vacio) b.vacio.hidden = true;
    }

    function abrirPanel() {
      var q = b.input.value.trim();
      b.panel.hidden = false;
      if (wrapper) wrapper.classList.add('predictivo-abierto');
      elevarSeccion(true);
      if (q.length < 2) {
        mostrarInicial();
      } else {
        buscar(q);
      }
    }

    function cerrarPanel() {
      b.panel.hidden = true;
      if (wrapper) {
        var hayOtroAbierto = wrapper.querySelector('[data-predictivo-panel]:not([hidden]), [data-predictivo-panel-movil]:not([hidden])');
        if (!hayOtroAbierto) {
          wrapper.classList.remove('predictivo-abierto');
          elevarSeccion(false);
        }
      }
    }

    function elevarSeccion(elevar) {
      var seccion = wrapper ? wrapper.closest('.shopify-section') : null;
      if (!seccion) return;
      if (elevar) {
        seccion.style.setProperty('position', 'relative', 'important');
        seccion.style.setProperty('z-index', '2147483647', 'important');
      } else {
        seccion.style.removeProperty('z-index');
        seccion.style.removeProperty('position');
      }
    }

    function buscar(query) {
      if (b.inicial) b.inicial.hidden = true;
      if (b.vacio) b.vacio.hidden = true;
      if (b.resultados) b.resultados.hidden = true;
      if (b.cargando) b.cargando.hidden = false;

      var url = config.suggestUrl + '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=' + config.limite +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (b.input.value.trim() !== query) return;
          pintarResultados(data, query);
        })
        .catch(function() {
          if (b.cargando) b.cargando.hidden = true;
          if (b.vacio) b.vacio.hidden = false;
        });
    }

    function pintarResultados(data, query) {
      if (b.cargando) b.cargando.hidden = true;
      var res = (data && data.resources && data.resources.results) ? data.resources.results : {};
      var productos = res.products || [];
      var colecciones = res.collections || [];
      var paginas = res.pages || [];

      if (productos.length === 0 && colecciones.length === 0 && paginas.length === 0) {
        if (b.vacio) b.vacio.hidden = false;
        if (b.resultados) b.resultados.hidden = true;
        return;
      }

      b.colIzq.innerHTML = '';
      b.colDer.innerHTML = '';

      if (colecciones.length > 0) {
        var gC = document.createElement('div');
        gC.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtCategorias) + '</p>';
        colecciones.forEach(function(c) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = c.url;
          var img = c.featured_image && c.featured_image.url ? '<img src="' + escapeHtml(c.featured_image.url) + '" alt="" loading="lazy" decoding="async" width="36" height="36">' : '';
          a.innerHTML = img + '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(c.title, query) + '</span></span>';
          gC.appendChild(a);
        });
        b.colIzq.appendChild(gC);
      }

      if (paginas.length > 0) {
        var gP = document.createElement('div');
        gP.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtPaginas) + '</p>';
        paginas.forEach(function(p) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = p.url;
          a.innerHTML = '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(p.title, query) + '</span></span>';
          gP.appendChild(a);
        });
        b.colIzq.appendChild(gP);
      }

      if (productos.length > 0) {
        var gPr = document.createElement('div');
        gPr.innerHTML = '<p class="encabezado-rafas__predictivo-grupo-titulo">' + escapeHtml(config.txtProductos) + '</p>';
        productos.slice(0, config.limiteIzq).forEach(function(p) {
          var a = document.createElement('a');
          a.className = 'encabezado-rafas__predictivo-fila';
          a.href = p.url;
          var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" loading="lazy" decoding="async" width="36" height="36">' : '';
          a.innerHTML = img + '<span class="encabezado-rafas__predictivo-fila-texto"><span class="encabezado-rafas__predictivo-fila-titulo">' + resaltar(p.title, query) + '</span></span>';
          a.addEventListener('click', function() {
            anadirAHistorial({ tipo: 'producto', titulo: p.title, url: p.url, imagen: (p.featured_image && p.featured_image.url) ? p.featured_image.url : '' });
          });
          gPr.appendChild(a);
        });
        var verTodos = document.createElement('a');
        verTodos.className = 'encabezado-rafas__predictivo-ver-todos';
        verTodos.href = config.searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
        verTodos.textContent = config.txtVerTodos;
        gPr.appendChild(verTodos);
        b.colIzq.appendChild(gPr);
      }

      productos.forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'encabezado-rafas__predictivo-prod';
        a.href = p.url;
        var img = p.featured_image && p.featured_image.url ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" loading="lazy" decoding="async" width="60" height="60">' : '<img src="" alt="" loading="lazy" decoding="async" width="60" height="60">';
        var precio = obtenerPrecio(p);
        a.innerHTML = img +
          '<span class="encabezado-rafas__predictivo-prod-info">' +
          '<span class="encabezado-rafas__predictivo-prod-titulo">' + resaltar(p.title, query) + '</span>' +
          (precio ? '<span class="encabezado-rafas__predictivo-prod-precio">' + precio + '</span>' : '') +
          '</span>';
        a.addEventListener('click', function() {
          anadirAHistorial({ tipo: 'producto', titulo: p.title, url: p.url, imagen: (p.featured_image && p.featured_image.url) ? p.featured_image.url : '' });
        });
        b.colDer.appendChild(a);
      });

      if (b.resultados) b.resultados.hidden = false;
    }

    function aDecimal(valor) {
      if (valor == null) return null;
      if (typeof valor === 'string') {
        var tieneDecimal = valor.indexOf('.') !== -1 || valor.indexOf(',') !== -1;
        var limpio = valor.replace(/[^0-9.,-]/g, '').replace(',', '.');
        var n = parseFloat(limpio);
        if (isNaN(n)) return null;
        if (tieneDecimal) return n;
        return n / 100;
      }
      if (typeof valor === 'number') {
        if (Number.isInteger(valor)) return valor / 100;
        return valor;
      }
      return null;
    }

    function obtenerPrecio(p) {
      var min = aDecimal(p.price_min != null ? p.price_min : p.price);
      var max = aDecimal(p.price_max != null ? p.price_max : p.price);
      if (min == null) return '';
      if (max != null && max > min) {
        return formatearNumero(min) + ' - ' + formatearNumero(max);
      }
      return formatearNumero(min);
    }

    function formatearNumero(num) {
      var str = num.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return str + ' ' + config.moneda;
    }

    b.input.addEventListener('input', function() {
      var q = b.input.value.trim();
      if (q === ultimaQuery) return;
      ultimaQuery = q;
      clearTimeout(timer);
      if (wrapper) wrapper.classList.add('predictivo-abierto');
      elevarSeccion(true);
      if (q.length < 2) {
        mostrarInicial();
        b.panel.hidden = false;
        return;
      }
      timer = setTimeout(function() { buscar(q); }, config.debounce);
    });

    b.input.addEventListener('focus', function() {
      abrirPanel();
    });

    var formDeEsteInput = b.input.closest('form');
    if (formDeEsteInput) {
      formDeEsteInput.addEventListener('submit', function() {
        var q = b.input.value.trim();
        if (q.length > 0) {
          anadirAHistorial({ tipo: 'busqueda', texto: q });
        }
      });
    }

    if (b.limpiar) {
      b.limpiar.addEventListener('click', function(e) {
        e.preventDefault();
        guardarHistorial([]);
        mostrarInicial();
      });
    }

    document.addEventListener('click', function(e) {
      if (b.panel.hidden) return;
      var contenedor = b.input.closest('.encabezado-rafas__buscador') || b.input.closest('.encabezado-rafas__buscador-movil');
      if (contenedor && !contenedor.contains(e.target)) {
        cerrarPanel();
      }
    });

    b.input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') cerrarPanel();
    });
  }

  function inicializarEncabezadoRafas(wrapper) {
    var tipoDesktop = wrapper.dataset.stickyDesktop || 'none';
    var tipoMovil = wrapper.dataset.stickyMovil || 'none';

    var inner = wrapper.querySelector('[data-encabezado-inner]');
    var placeholder = wrapper.querySelector('[data-encabezado-placeholder]');
    if (!inner || !placeholder) return;

    var scrollAnterior = 0;
    var ticking = false;
    var estadoFijo = false;
    var timeoutOcultar = null;
    var seccionSticky = wrapper.closest('.shopify-section');

    function aplicarStickySeccion() {
      if (!seccionSticky) return;
      if (getTipoActivo() === 'always') {
        seccionSticky.classList.add('enc-seccion-fija');
      } else {
        seccionSticky.classList.remove('enc-seccion-fija');
      }
    }

    var mqDesktop = window.matchMedia('(min-width: 990px)');
    function esDesktop() { return mqDesktop.matches; }
    function getTipoActivo() { return esDesktop() ? tipoDesktop : tipoMovil; }

    function aplicarClasesModo() {
      wrapper.classList.remove('modo-d-always', 'modo-d-subida', 'modo-m-always', 'modo-m-subida');
      if (tipoDesktop === 'always') wrapper.classList.add('modo-d-always');
      if (tipoDesktop === 'on-scroll-up') wrapper.classList.add('modo-d-subida');
      if (tipoMovil === 'always') wrapper.classList.add('modo-m-always');
      if (tipoMovil === 'on-scroll-up') wrapper.classList.add('modo-m-subida');
    }

    var alturaHeaderCache = 0;

    var alturaAplicada = -1;

    placeholder.style.height = '0';
    placeholder.style.display = 'none';

    function actualizarAltura() {
      var altura = inner.getBoundingClientRect().height || inner.offsetHeight;
      alturaHeaderCache = altura;
      if (altura === alturaAplicada) return;
      alturaAplicada = altura;
      document.documentElement.style.setProperty('--header-height', altura + 'px');
    }

    function programarAltura() {
      requestAnimationFrame(function() {
        requestAnimationFrame(actualizarAltura);
      });
    }

    aplicarClasesModo();
    aplicarStickySeccion();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(actualizarAltura);
      ro.observe(inner);
      window.addEventListener('resize', aplicarStickySeccion);
    } else {
      programarAltura();
      setTimeout(programarAltura, 100);
      setTimeout(programarAltura, 500);
      window.addEventListener('resize', function() { aplicarStickySeccion(); programarAltura(); });
    }

    function activarFijo() {
      if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
      if (estadoFijo) return;
      wrapper.classList.add('fijo');
      wrapper.classList.add('encabezado-animando');
      requestAnimationFrame(function() { wrapper.classList.add('visible'); });
      estadoFijo = true;
      setTimeout(function() { wrapper.classList.remove('encabezado-animando'); }, 350);
    }

    function desactivarFijo() {
      if (!estadoFijo) return;
      wrapper.classList.add('encabezado-animando');
      wrapper.classList.remove('visible');
      timeoutOcultar = setTimeout(function() {
        wrapper.classList.remove('fijo');
        wrapper.classList.remove('encabezado-animando');
        estadoFijo = false;
        timeoutOcultar = null;
      }, 320);
    }

    function desactivarFijoInmediato() {
      if (!estadoFijo) return;
      if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
      wrapper.classList.add('mm-sin-transicion');
      wrapper.classList.remove('visible');
      wrapper.classList.remove('fijo');
      wrapper.classList.remove('encabezado-animando');
      estadoFijo = false;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          wrapper.classList.remove('mm-sin-transicion');
        });
      });
    }

    function manejarScroll() {
      var tipoActivo = getTipoActivo();
      var scrollActual = window.scrollY || 0;
      var diferencia = scrollActual - scrollAnterior;

      if (tipoActivo === 'none') {
        if (estadoFijo) desactivarFijoInmediato();
        wrapper.classList.remove('tiene-sombra');
        scrollAnterior = scrollActual;
        ticking = false;
        return;
      }

      if (tipoActivo === 'always') {
        if (scrollActual > 5) {
          wrapper.classList.add('tiene-sombra');
        } else {
          wrapper.classList.remove('tiene-sombra');
        }
      } else if (tipoActivo === 'on-scroll-up') {
        var alturaHeader = alturaHeaderCache || inner.offsetHeight;
        if (scrollActual <= 5) {
          if (estadoFijo) { desactivarFijoInmediato(); }
          ticking = false;
          scrollAnterior = scrollActual;
          return;
        }
        if (diferencia < -3 && scrollActual > alturaHeader) {
          activarFijo();
        } else if (diferencia > 3) {
          desactivarFijo();
        }
      }

      scrollAnterior = scrollActual;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(manejarScroll);
        ticking = true;
      }
    }, { passive: true });

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        scrollAnterior = window.scrollY || 0;
        manejarScroll();
      });
    });
  }

  function inicializarTodo() {
    var wrappers = document.querySelectorAll('.encabezado-rafas-wrapper');
    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.rafasInicializado === 'true') return;
      wrapper.dataset.rafasInicializado = 'true';
      inicializarEncabezadoRafas(wrapper);
      inicializarBuscador(wrapper);

      if (wrapper.dataset.predictivoActivar === 'true') {
        inicializarPredictivo(wrapper, {
          suggestUrl: wrapper.dataset.predictivoSuggestUrl,
          searchUrl: wrapper.dataset.predictivoSearchUrl,
          limite: parseInt(wrapper.dataset.predictivoLimite, 10) || 6,
          limiteIzq: parseInt(wrapper.dataset.predictivoLimiteIzq, 10) || 3,
          debounce: parseInt(wrapper.dataset.predictivoDebounce, 10) || 250,
          moneda: wrapper.dataset.predictivoMoneda || '',
          txtCategorias: wrapper.dataset.predictivoTxtCategorias || 'Categorias',
          txtPaginas: wrapper.dataset.predictivoTxtPaginas || 'Paginas',
          txtProductos: wrapper.dataset.predictivoTxtProductos || 'Productos',
          txtVerTodos: wrapper.dataset.predictivoTxtVertodos || 'Ver todos los productos'
        });
      }

      var btn = wrapper.querySelector('[data-toggle-buscador-movil]');
      var panel = wrapper.querySelector('[data-buscador-movil]');
      if (btn && panel) {
        btn.addEventListener('click', function() {
          var oculto = panel.hasAttribute('hidden');
          if (oculto) {
            panel.removeAttribute('hidden');
            var input = panel.querySelector('input[type="search"]');
            if (input) setTimeout(function() { input.focus(); }, 50);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      var btnMega = wrapper.querySelector('[data-abrir-megamenu]');
      if (btnMega) {
        btnMega.addEventListener('click', function() {
          document.dispatchEvent(new CustomEvent('megamenu:abrir'));
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodo);
  } else {
    inicializarTodo();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.encabezado-rafas-wrapper')) {
      inicializarTodo();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header01"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarMegamenu(wrapper) {

      if (wrapper.dataset.mmInicializado === '1') return;
      wrapper.dataset.mmInicializado = '1';

      var sectionIdMm = (wrapper.id || '').replace('megamenu-', '');
      var huerfanos = document.querySelectorAll('body > [data-mm-id="' + sectionIdMm + '"]');
      huerfanos.forEach(function(o) {
        if (!wrapper.contains(o)) o.remove();
      });

      var btnAbrir = wrapper.querySelector('[data-abrir-movil]');
      var btnsCerrar = wrapper.querySelectorAll('[data-cerrar-movil]');
      var panel = wrapper.querySelector('[data-panel-movil]');
      var overlay = wrapper.querySelector('.mm-movil-overlay');
      var ladoApertura = wrapper.dataset.movilLado || 'derecha';

      var abriendoAhora = false;

      function abrir() {
        if (panel && panel.parentElement !== document.body) {
          document.body.appendChild(panel);
        }
        if (overlay && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }
        if (panel) panel.classList.add('mm-abierto');
        if (overlay) overlay.classList.add('mm-abierto');
        document.body.style.overflow = 'hidden';
        abriendoAhora = true;
        setTimeout(function() { abriendoAhora = false; }, 300);
      }
      function cerrar() {
        if (panel) panel.classList.remove('mm-abierto');
        if (overlay) overlay.classList.remove('mm-abierto');
        document.body.style.overflow = '';
      }

      if (btnAbrir) btnAbrir.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        abrir();
      });
      btnsCerrar.forEach(function(b) {
        b.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          cerrar();
        });
      });

      if (overlay) {
        overlay.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          cerrar();
        });
        overlay.addEventListener('touchend', function(e) {
          e.preventDefault();
          e.stopPropagation();
          cerrar();
        }, { passive: false });
      }

      document.addEventListener('click', function(e) {
        if (abriendoAhora) return;
        if (!panel || !panel.classList.contains('mm-abierto')) return;
        if (panel.contains(e.target)) return;
        if (e.target.closest && e.target.closest('[data-abrir-movil]')) return;
        cerrar();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && panel && panel.classList.contains('mm-abierto')) {
          cerrar();
        }
      });

      document.addEventListener('megamenu:abrir', abrir);

      var toggles = wrapper.querySelectorAll('[data-acordeon]');
      toggles.forEach(function(t) {
        t.addEventListener('click', function() {
          var contenido = t.nextElementSibling;
          if (!contenido) return;
          var estaAbierto = t.classList.contains('mm-abierto');

          toggles.forEach(function(otro) {
            if (otro !== t) {
              otro.classList.remove('mm-abierto');
              var otroContenido = otro.nextElementSibling;
              if (otroContenido) otroContenido.classList.remove('mm-abierto');
            }
          });

          if (estaAbierto) {
            t.classList.remove('mm-abierto');
            contenido.classList.remove('mm-abierto');
          } else {
            t.classList.add('mm-abierto');
            contenido.classList.add('mm-abierto');
          }
        });
      });

      if (panel) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touchCurrentX = 0;
        var arrastrando = false;
        var direccionDetectada = null;

        panel.addEventListener('touchstart', function(e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchCurrentX = touchStartX;
          arrastrando = false;
          direccionDetectada = null;
        }, { passive: true });

        panel.addEventListener('touchmove', function(e) {
          if (e.touches.length !== 1) return;
          var deltaX = e.touches[0].clientX - touchStartX;
          var deltaY = e.touches[0].clientY - touchStartY;

          if (direccionDetectada === null) {
            if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8) {
              direccionDetectada = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
            } else {
              return;
            }
          }

          if (direccionDetectada !== 'h') return;

          var deltaCierre = ladoApertura === 'izquierda' ? -deltaX : deltaX;
          if (deltaCierre <= 0) return;

          arrastrando = true;
          touchCurrentX = e.touches[0].clientX;
          panel.classList.add('mm-arrastrando');
          var translateX = ladoApertura === 'izquierda' ? -deltaCierre : deltaCierre;
          panel.style.transform = 'translateX(' + translateX + 'px)';

          var opacidad = 1 - Math.min(deltaCierre / panel.offsetWidth, 1);
          if (overlay) overlay.style.opacity = (opacidad * 0.5).toString();
        }, { passive: true });

        panel.addEventListener('touchend', function() {
          if (!arrastrando) {
            direccionDetectada = null;
            return;
          }
          panel.classList.remove('mm-arrastrando');
          panel.style.transform = '';
          if (overlay) overlay.style.opacity = '';

          var deltaX = touchCurrentX - touchStartX;
          var deltaCierre = ladoApertura === 'izquierda' ? -deltaX : deltaX;
          var umbral = panel.offsetWidth * 0.3;

          if (deltaCierre > umbral) {
            cerrar();
          }
          arrastrando = false;
          direccionDetectada = null;
        }, { passive: true });

        panel.addEventListener('touchcancel', function() {
          panel.classList.remove('mm-arrastrando');
          panel.style.transform = '';
          if (overlay) overlay.style.opacity = '';
          arrastrando = false;
          direccionDetectada = null;
        }, { passive: true });
      }

      var items = wrapper.querySelectorAll('.mm-item-mega');
      items.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          var mega = item.querySelector('[data-mega]');
          if (!mega) return;
          if (mega.classList.contains('mm-mega--completo')) return;

          mega.style.removeProperty('--mm-shift-x');

          requestAnimationFrame(function() {
            var rect = mega.getBoundingClientRect();
            var viewportWidth = window.innerWidth;
            var margen = 16;
            var ajuste = 0;

            if (rect.right > viewportWidth - margen) {
              ajuste = -(rect.right - (viewportWidth - margen));
            } else if (rect.left < margen) {
              ajuste = margen - rect.left;
            }

            if (ajuste !== 0) {
              mega.style.setProperty('--mm-shift-x', ajuste + 'px');
            }
          });
        });
      });
      var tipoDesktop = wrapper.dataset.stickyDesktop || 'none';
      var tipoMovil = wrapper.dataset.stickyMovil || 'none';
      var inner = wrapper.querySelector('[data-mm-inner]');
      var placeholder = wrapper.querySelector('[data-mm-placeholder]');

      if ((tipoDesktop !== 'none' || tipoMovil !== 'none') && inner && placeholder) {
        var scrollAnterior = 0;
        var ticking = false;
        var estadoFijo = false;
        var timeoutOcultar = null;

        var mqDesktopMm = window.matchMedia('(min-width: 990px)');
        function esDesktop() {
          return mqDesktopMm.matches;
        }
        function getTipoActivo() {
          return esDesktop() ? tipoDesktop : tipoMovil;
        }
        function aplicarClasesModo() {
          wrapper.classList.remove('mm-modo-d-always', 'mm-modo-d-subida', 'mm-modo-m-always', 'mm-modo-m-subida');
          if (tipoDesktop === 'always') wrapper.classList.add('mm-modo-d-always');
          if (tipoDesktop === 'on-scroll-up') wrapper.classList.add('mm-modo-d-subida');
          if (tipoMovil === 'always') wrapper.classList.add('mm-modo-m-always');
          if (tipoMovil === 'on-scroll-up') wrapper.classList.add('mm-modo-m-subida');
        }
        var seccionSticky = wrapper.closest('.shopify-section');
        function aplicarStickySeccion() {
          if (!seccionSticky) return;
          if (getTipoActivo() === 'always') {
            var cs = getComputedStyle(wrapper);
            seccionSticky.style.setProperty('--mm-sticky-top', cs.getPropertyValue('--mm-sticky-top').trim() || '0px');
            seccionSticky.style.setProperty('--mm-sticky-z', cs.getPropertyValue('--mm-sticky-z').trim() || '80');
            seccionSticky.classList.add('mm-seccion-fija');
          } else {
            seccionSticky.classList.remove('mm-seccion-fija');
          }
        }
        var alturaMenuCache = 0;

        placeholder.style.height = '0';
        placeholder.style.display = 'none';
        function actualizarAltura() {
          alturaMenuCache = inner.getBoundingClientRect().height || inner.offsetHeight;
        }
        function programarAltura() {
          requestAnimationFrame(function() {
            requestAnimationFrame(actualizarAltura);
          });
        }
        aplicarClasesModo();
        aplicarStickySeccion();
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(actualizarAltura);
          ro.observe(inner);
          window.addEventListener('resize', aplicarStickySeccion);
        } else {
          programarAltura();
          setTimeout(programarAltura, 100);
          setTimeout(programarAltura, 500);
          window.addEventListener('resize', function() { aplicarStickySeccion(); programarAltura(); });
        }

        var timeoutAnimando = null;
        function activarFijo() {
          if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
          if (estadoFijo) return;
          wrapper.classList.add('mm-animando');
          wrapper.classList.add('mm-fijo');
          requestAnimationFrame(function() { wrapper.classList.add('mm-visible'); });
          estadoFijo = true;
          if (timeoutAnimando) clearTimeout(timeoutAnimando);
          timeoutAnimando = setTimeout(function() { wrapper.classList.remove('mm-animando'); timeoutAnimando = null; }, 350);
        }
        function desactivarFijo() {
          if (!estadoFijo) return;
          wrapper.classList.add('mm-animando');
          wrapper.classList.remove('mm-visible');
          if (timeoutAnimando) clearTimeout(timeoutAnimando);
          timeoutOcultar = setTimeout(function() {
            wrapper.classList.remove('mm-fijo');
            wrapper.classList.remove('mm-animando');
            estadoFijo = false;
            timeoutOcultar = null;
          }, 320);
        }
        function desactivarFijoInmediato() {
          if (!estadoFijo) return;
          if (timeoutOcultar) { clearTimeout(timeoutOcultar); timeoutOcultar = null; }
          if (timeoutAnimando) { clearTimeout(timeoutAnimando); timeoutAnimando = null; }
          wrapper.classList.add('mm-sin-transicion');
          wrapper.classList.remove('mm-visible');
          wrapper.classList.remove('mm-fijo');
          wrapper.classList.remove('mm-animando');
          estadoFijo = false;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              wrapper.classList.remove('mm-sin-transicion');
            });
          });
        }

        function manejarScrollSticky() {
          var tipoActivo = getTipoActivo();
          var scrollActual = window.scrollY || 0;
          var diferencia = scrollActual - scrollAnterior;

          if (tipoActivo === 'none') {
            if (estadoFijo) desactivarFijoInmediato();
            wrapper.classList.remove('mm-tiene-sombra');
            scrollAnterior = scrollActual;
            ticking = false;
            return;
          }
          if (tipoActivo === 'always') {
            if (scrollActual > 5) wrapper.classList.add('mm-tiene-sombra');
            else wrapper.classList.remove('mm-tiene-sombra');
          } else if (tipoActivo === 'on-scroll-up') {
            var alturaHeader = alturaMenuCache || inner.offsetHeight;
            if (scrollActual <= 5) {
              if (estadoFijo) desactivarFijoInmediato();
              ticking = false;
              scrollAnterior = scrollActual;
              return;
            }
            if (diferencia < -3 && scrollActual > alturaHeader) activarFijo();
            else if (diferencia > 3) desactivarFijo();
          }
          scrollAnterior = scrollActual;
          ticking = false;
        }

        window.addEventListener('scroll', function() {
          if (!ticking) {
            window.requestAnimationFrame(manejarScrollSticky);
            ticking = true;
          }
        }, { passive: true });

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            scrollAnterior = window.scrollY || 0;
            manejarScrollSticky();
          });
        });
      }

      var diOverlay = wrapper.querySelector('[data-di-overlay]');
      var diPanel = wrapper.querySelector('[data-di-panel]');
      var diBotonesAbrir = wrapper.querySelectorAll('[data-di-abrir]');
      var diBotonCerrar = wrapper.querySelector('[data-di-cerrar]');
      var diFormulario = wrapper.querySelector('[data-di-formulario]');
      var diToggleLogo = wrapper.querySelector('[data-di-toggle-logo]');
      var diTextoToggle = wrapper.querySelector('[data-di-toggle-texto]');
      var diVistaFormulario = wrapper.querySelector('[data-di-vista="formulario"]');
      var diVistaResultados = wrapper.querySelector('[data-di-vista="resultados"]');
      var diVistaCargando = wrapper.querySelector('[data-di-vista="cargando"]');
      var diResultadosGrid = wrapper.querySelector('[data-di-resultados]');
      var diSinResultados = wrapper.querySelector('[data-di-sin-resultados]');
      var diBotonVolver = wrapper.querySelector('[data-di-volver]');
      var diResumen = wrapper.querySelector('[data-di-resumen]');

      if (diPanel && diOverlay && diFormulario && diBotonesAbrir.length) {
        var diTextoConLogo = wrapper.dataset.diTextoConLogo || '';
        var diTextoSinLogo = wrapper.dataset.diTextoSinLogo || '';
        var diCacheProductos = null;

        function diAbrir() {
          if (panel && panel.classList.contains('mm-abierto')) {
            cerrar();
          }
          if (diPanel.parentElement !== document.body) document.body.appendChild(diPanel);
          if (diOverlay.parentElement !== document.body) document.body.appendChild(diOverlay);
          diPanel.hidden = false;
          diOverlay.hidden = false;
          diOverlay.classList.add('di-animando');
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              diPanel.classList.add('di-activo');
              diOverlay.classList.add('di-activo');
            });
          });
          document.body.classList.add('di-bloqueado');
          setTimeout(function() { diOverlay.classList.remove('di-animando'); }, 350);
        }

        function diCerrar() {
          diOverlay.classList.add('di-animando');
          diPanel.classList.remove('di-activo');
          diOverlay.classList.remove('di-activo');
          setTimeout(function() {
            diPanel.hidden = true;
            diOverlay.hidden = true;
            diOverlay.classList.remove('di-animando');
            document.body.classList.remove('di-bloqueado');
          }, 320);
        }

        function diMostrarVista(nombre) {
          diVistaFormulario.hidden = nombre !== 'formulario';
          diVistaResultados.hidden = nombre !== 'resultados';
          diVistaCargando.hidden = nombre !== 'cargando';
          if (diBotonVolver) {
            diBotonVolver.hidden = nombre !== 'resultados';
          }
        }

        if (diToggleLogo && diTextoToggle) {
          diToggleLogo.addEventListener('change', function() {
            diTextoToggle.textContent = diToggleLogo.checked ? diTextoConLogo : diTextoSinLogo;
          });
        }

        diBotonesAbrir.forEach(function(b) {
          b.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            diAbrir();
          });
        });
        if (diBotonCerrar) diBotonCerrar.addEventListener('click', diCerrar);
        diOverlay.addEventListener('click', diCerrar);
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && !diPanel.hidden) diCerrar();
        });
        if (diBotonVolver) {
          diBotonVolver.addEventListener('click', function() {
            diMostrarVista('formulario');
          });
        }

        function diFormatearPrecio(euros) {
          return euros.toFixed(2).replace('.', ',') + ' €';
        }

        var diProductosCompletos = [];
        var diProductosMostrados = 0;
        var diProductosPorPagina = parseInt(wrapper.dataset.diPorPagina, 10) || 12;
        var diVerMasWrapper = wrapper.querySelector('[data-di-ver-mas-wrapper]');
        var diBotonVerMas = wrapper.querySelector('[data-di-ver-mas]');

        function diCrearTarjeta(p) {
          var a = document.createElement('a');
          a.className = 'di-producto';
          a.href = p.url;
          var imgWrapper = document.createElement('div');
          imgWrapper.className = 'di-producto-imagen-wrapper';
          if (p.imagen) {
            var img = document.createElement('img');
            img.className = 'di-producto-imagen';
            img.src = p.imagen;
            img.alt = p.titulo;
            img.loading = 'lazy';
            img.decoding = 'async';
            img.width = 300;
            img.height = 300;
            imgWrapper.appendChild(img);
          }
          var infoEl = document.createElement('div');
          infoEl.className = 'di-producto-info';
          var titulo = document.createElement('h4');
          titulo.className = 'di-producto-titulo';
          titulo.textContent = p.titulo;
          var precio = document.createElement('span');
          precio.className = 'di-producto-precio';
          precio.textContent = p.precioTexto;
          infoEl.appendChild(titulo);
          infoEl.appendChild(precio);
          a.appendChild(imgWrapper);
          a.appendChild(infoEl);
          return a;
        }

        function diRenderizarSiguienteLote() {
          var lote = diProductosCompletos.slice(diProductosMostrados, diProductosMostrados + diProductosPorPagina);
          var fragmento = document.createDocumentFragment();
          lote.forEach(function(p) {
            fragmento.appendChild(diCrearTarjeta(p));
          });
          diResultadosGrid.appendChild(fragmento);
          diProductosMostrados += lote.length;

          if (diVerMasWrapper) {
            if (diProductosMostrados < diProductosCompletos.length) {
              diVerMasWrapper.hidden = false;
            } else {
              diVerMasWrapper.hidden = true;
            }
          }
        }

        function diRenderizarProductos(productos, info) {
          diProductosCompletos = productos;
          diProductosMostrados = 0;
          diResultadosGrid.innerHTML = '';
          if (diResumen) diResumen.textContent = info || '';
          if (diVerMasWrapper) diVerMasWrapper.hidden = true;
          if (!productos.length) {
            diSinResultados.hidden = false;
            return;
          }
          diSinResultados.hidden = true;
          diRenderizarSiguienteLote();
        }

        if (diBotonVerMas) {
          diBotonVerMas.addEventListener('click', diRenderizarSiguienteLote);
        }

        function diObtenerProductos(collectionHandle) {
          if (!diCacheProductos) diCacheProductos = {};
          var cacheKey = collectionHandle || '__todos__';
          if (diCacheProductos[cacheKey]) return Promise.resolve(diCacheProductos[cacheKey]);

          var endpoint = collectionHandle
            ? '/collections/' + collectionHandle + '/products.json'
            : '/products.json';
          var todos = [];
          var limite = 250;
          var maxPaginas = 6;

          function fetchPagina(pagina) {
            if (pagina > maxPaginas) {
              diCacheProductos[cacheKey] = todos;
              return todos;
            }
            return fetch(endpoint + '?limit=' + limite + '&page=' + pagina, {
              headers: { 'Accept': 'application/json' }
            }).then(function(resp) {
              if (!resp.ok) {
                diCacheProductos[cacheKey] = todos;
                return todos;
              }
              return resp.json();
            }).then(function(data) {
              if (!data || !data.products || !data.products.length) {
                diCacheProductos[cacheKey] = todos;
                return todos;
              }
              for (var i = 0; i < data.products.length; i++) todos.push(data.products[i]);
              if (data.products.length < limite) {
                diCacheProductos[cacheKey] = todos;
                return todos;
              }
              return fetchPagina(pagina + 1);
            }).catch(function() {
              diCacheProductos[cacheKey] = todos;
              return todos;
            });
          }
          return fetchPagina(1);
        }

        function diFiltrarProductos(productosRaw, precioMin, precioMax) {
          var filtrados = [];
          productosRaw.forEach(function(producto) {
            if (!producto.variants || !producto.variants.length) return;
            var precios = producto.variants
              .filter(function(v) { return v.available !== false; })
              .map(function(v) { return parseFloat(v.price); })
              .filter(function(p) { return !isNaN(p); });
            if (!precios.length) return;
            var precioMinProducto = Math.min.apply(null, precios);
            if (precioMinProducto < precioMin || precioMinProducto > precioMax) return;

            var imagen = producto.images && producto.images.length ? producto.images[0].src : null;
            filtrados.push({
              titulo: producto.title,
              url: '/products/' + producto.handle,
              precio: precioMinProducto,
              precioTexto: diFormatearPrecio(precioMinProducto),
              imagen: imagen
            });
          });
          filtrados.sort(function(a, b) { return a.precio - b.precio; });
          return filtrados;
        }

        diFormulario.addEventListener('submit', function(e) {
          e.preventDefault();
          var presupuestoVal = diFormulario.querySelector('[name="presupuesto"]').value;
          var tipoSelect = diFormulario.querySelector('[name="tipo"]');
          var tipoVal = tipoSelect ? tipoSelect.value : '';
          var tipoLabel = tipoSelect && tipoSelect.selectedOptions.length ? tipoSelect.selectedOptions[0].textContent : '';
          if (!presupuestoVal) return;
          var partes = presupuestoVal.split('|');
          var precioMin = parseFloat(partes[0]);
          var precioMax = parseFloat(partes[1]);
          var presupuestoLabel = diFormulario.querySelector('[name="presupuesto"]').selectedOptions[0].textContent;

          diMostrarVista('cargando');
          diObtenerProductos(tipoVal).then(function(productosRaw) {
            var productos = diFiltrarProductos(productosRaw, precioMin, precioMax);
            var infoTexto = productos.length + ' ideas · ' + presupuestoLabel + ' · ' + tipoLabel;
            diMostrarVista('resultados');
            diRenderizarProductos(productos, infoTexto);
          });
        });
      }
  }
  document.querySelectorAll('.mm-wrapper').forEach(inicializarMegamenu);
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target) e.target.querySelectorAll('.mm-wrapper').forEach(inicializarMegamenu);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-layout-coleccion"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.cl-coleccion-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.clInicializado === 'true') return;
      seccion.dataset.clInicializado = 'true';

      var contenido = seccion.querySelector('[data-cl-contenido]');
      var tocWrapper = seccion.querySelector('[data-cl-toc]');
      var tocList = seccion.querySelector('[data-cl-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'cl-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-main-404"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.documentElement.querySelectorAll('meta[name="robots"]').forEach(function(m) {
    m.parentNode.removeChild(m);
  });
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'robots');
  meta.setAttribute('content', 'noindex, follow');
  document.head.appendChild(meta);

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view_404', {
      page_path: window.location.pathname + window.location.search,
      page_referrer: document.referrer
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-pedidos"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init() {
    var secciones = document.querySelectorAll('.pl-pagina-layout');
    secciones.forEach(function(seccion) {
      if (seccion.dataset.plInicializado === 'true') return;
      seccion.dataset.plInicializado = 'true';

      var contenido = seccion.querySelector('[data-pl-contenido]');
      var tocWrapper = seccion.querySelector('[data-pl-toc]');
      var tocList = seccion.querySelector('[data-pl-toc-list]');

      if (!contenido || !tocWrapper || !tocList) return;

      function slugify(text) {
        return String(text || '')
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var h2s = contenido.querySelectorAll('h2');
      if (h2s.length === 0) {
        tocWrapper.hidden = true;
        return;
      }

      var slugsUsados = {};
      h2s.forEach(function(h2, i) {
        var slugBase = slugify(h2.textContent) || ('seccion-' + (i + 1));
        var slug = slugBase;
        var contador = 2;
        while (slugsUsados[slug]) {
          slug = slugBase + '-' + contador;
          contador++;
        }
        slugsUsados[slug] = true;

        if (!h2.id) h2.id = slug;
        var slugFinal = h2.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + slugFinal;
        a.className = 'pl-toc-link';
        a.textContent = h2.textContent;

        a.addEventListener('click', function(e) {
          e.preventDefault();
          var target = document.getElementById(slugFinal);
          if (!target) return;
          var offset = 100;
          var pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: pos, behavior: 'smooth' });
          if (history.replaceState) history.replaceState(null, '', '#' + slugFinal);
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      tocWrapper.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-seccion-colecciones"] && !Shopify.designMode) return;
  try {
    
(function() {
  var secciones = document.querySelectorAll('.sol-sec-seccion');
  if (!secciones.length) return;

  if (!('IntersectionObserver' in window)) {
    secciones.forEach(function(s) { s.classList.remove('sol-sec-revelar'); });
    return;
  }

  secciones.forEach(function(seccion) {
    seccion.classList.add('sol-sec-revelar');
  });

  var observador = new IntersectionObserver(function(entradas) {
    entradas.forEach(function(entrada) {
      if (entrada.isIntersecting) {
        entrada.target.classList.add('sol-sec-visible');
        observador.unobserve(entrada.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -40px 0px'
  });

  secciones.forEach(function(seccion) {
    observador.observe(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-seccion4"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ctf]').forEach(function(seccion) {
      seccion.classList.add('ctf-revelar');

      var observadorReveal = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ctf-visible');
            observadorReveal.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      observadorReveal.observe(seccion);

      var observadorViewport = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ctf-en-viewport');
          } else {
            entry.target.classList.remove('ctf-en-viewport');
          }
        });
      }, { rootMargin: '100px 0px' });
      observadorViewport.observe(seccion);

      var activo = seccion.dataset.tiltActivo === 'true';
      if (!activo) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia('(hover: none)').matches) return;

      var wrapper = seccion.querySelector('[data-tilt-wrapper]');
      var target = seccion.querySelector('[data-tilt-target]');
      if (!wrapper || !target) return;

      var intensidad = parseFloat(seccion.dataset.tiltIntensidad) || 8;
      var ticking = false;
      var lastX = 0;
      var lastY = 0;

      function actualizar() {
        var rect = wrapper.getBoundingClientRect();
        var x = lastX - rect.left;
        var y = lastY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = ((y - centerY) / centerY) * -intensidad;
        var rotateY = ((x - centerX) / centerX) * intensidad;
        target.style.transform = 'perspective(1200px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(1.02)';
        ticking = false;
      }

      wrapper.addEventListener('mouseenter', function() {
        target.style.willChange = 'transform';
      });

      wrapper.addEventListener('mousemove', function(e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!ticking) {
          window.requestAnimationFrame(actualizar);
          ticking = true;
        }
      });

      wrapper.addEventListener('mouseleave', function() {
        target.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) scale(1)';
        target.style.willChange = 'auto';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-tarjeta"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarTpd(seccion) {
    if (seccion.dataset.tpdInicializado === 'true') return;
    seccion.dataset.tpdInicializado = 'true';

      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reducido && 'IntersectionObserver' in window) {
        seccion.classList.add('tpd-revelar');
        var observadorReveal = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              seccion.classList.add('tpd-will-change');
              requestAnimationFrame(function() {
                seccion.classList.add('tpd-visible');
              });
              setTimeout(function() {
                seccion.classList.remove('tpd-will-change');
              }, 900);
              observadorReveal.disconnect();
            }
          });
        }, { threshold: 0.05 });
        observadorReveal.observe(seccion);
      }

      function enlazarHoverVariantes(card) {
        var imagenPrincipal = card.querySelector('[data-img-principal]');
        var variantes = card.querySelectorAll('[data-variante-img]');

        if (!imagenPrincipal) return;
        var srcOriginal = imagenPrincipal.src;

        var hoverImg = card.querySelector('[data-img-hover]');
        if (hoverImg && window.matchMedia('(hover: hover)').matches) {
          card.addEventListener('mouseenter', function() {
            if (!hoverImg.getAttribute('src')) {
              hoverImg.onload = function() {
                hoverImg.classList.add('tpd-img-hover-lista');
              };
              hoverImg.src = hoverImg.dataset.imgHover;
            }
          });
        }

        if (window.matchMedia('(hover: hover)').matches) {
          variantes.forEach(function(spn) {
            spn.addEventListener('mouseenter', function(e) {
              e.stopPropagation();
              card.classList.add('tpd-hover-variante');
              var nuevaImg = spn.dataset.varianteImg;
              if (nuevaImg) imagenPrincipal.src = nuevaImg;
            });
          });

          var contenedorVariantes = card.querySelector('[data-variantes]');
          if (contenedorVariantes) {
            contenedorVariantes.addEventListener('mouseleave', function() {
              card.classList.remove('tpd-hover-variante');
              imagenPrincipal.src = srcOriginal;
            });
          }
        }
      }

      seccion.querySelectorAll('.tpd-card').forEach(enlazarHoverVariantes);

      var pista = seccion.querySelector('[data-grid-productos]');
      var flechaPrev = seccion.querySelector('[data-flecha-prev]');
      var flechaNext = seccion.querySelector('[data-flecha-next]');
      if (pista && flechaPrev && flechaNext) {
        function pasoCarrusel() {
          var card = pista.querySelector('.tpd-card');
          if (!card) return 0;
          var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        }
        var maxScrollCache = -1;
        function medirCarrusel() {
          maxScrollCache = pista.scrollWidth - pista.clientWidth - 2;
        }
        function estadoFlechas() {
          if (maxScrollCache < 0) medirCarrusel();
          var sl = pista.scrollLeft;
          flechaPrev.classList.toggle('tpd-flecha-off', sl <= 2);
          flechaNext.classList.toggle('tpd-flecha-off', sl >= maxScrollCache);
        }
        flechaPrev.addEventListener('click', function() { pista.scrollBy({ left: -pasoCarrusel(), behavior: 'smooth' }); });
        flechaNext.addEventListener('click', function() { pista.scrollBy({ left: pasoCarrusel(), behavior: 'smooth' }); });
        var tickFlechas = false;
        pista.addEventListener('scroll', function() {
          if (tickFlechas) return;
          tickFlechas = true;
          requestAnimationFrame(function() { estadoFlechas(); tickFlechas = false; });
        }, { passive: true });
        window.addEventListener('resize', function() { medirCarrusel(); estadoFlechas(); });
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            medirCarrusel();
            estadoFlechas();
          });
        });
      }

  }
  document.querySelectorAll('.tpd-seccion').forEach(inicializarTpd);
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target) e.target.querySelectorAll('.tpd-seccion').forEach(inicializarTpd);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
